import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormControl, Select, MenuItem, Box, Typography } from '@mui/material';
import ReactCountryFlag from 'react-country-flag';

import { setLanguage } from 'store/appReducer';

const languages = [
    { code: 'en', label: 'English', country: 'US' },
    { code: 'id', label: 'Bahasa Indonesia', country: 'ID' },
    { code: 'my', label: 'မြန်မာဘာသာ', country: 'MM' }
];

export default function LanguageSelector(props) {
    const dispatch = useDispatch();
    const locale = useSelector((state) => state.app.locale);
    const { sx, noOutline } = props;

    const handleChange = (event) => {
        dispatch(setLanguage(event.target.value));
    };

    const selectedLang = languages.find((l) => l.code === locale);

    return (
        <FormControl size="small" sx={sx}>
            <Select
                value={locale}
                onChange={handleChange}
                disableUnderline
                {...(noOutline && { variant: 'standard' })}
                renderValue={() => (
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: 36,
                            height: 36,
                            borderRadius: '50%',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease',
                            '&:hover': {
                                backgroundColor: 'rgba(0,0,0,0.05)'
                            }
                        }}
                    >
                        <ReactCountryFlag
                            svg
                            countryCode={selectedLang.country}
                            style={{
                                width: '1.5em',
                                height: '1.5em',
                                borderRadius: '2px'
                            }}
                        />
                    </Box>
                )}
                MenuProps={{
                    anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'right' // 👈 align to right of trigger
                    },
                    transformOrigin: {
                        vertical: 'top',
                        horizontal: 'right' // 👈 dropdown grows from right
                    },
                    PaperProps: {
                        sx: {
                            mt: 1,
                            borderRadius: 2,
                            minWidth: 180,
                            boxShadow: 3
                        }
                    }
                }}
            >
                {languages.map((lang) => (
                    <MenuItem
                        key={lang.code}
                        value={lang.code}
                        sx={{
                            display: 'flex',
                            gap: 1.5,
                            alignItems: 'center',
                            py: 1
                        }}
                    >
                        <ReactCountryFlag
                            svg
                            countryCode={lang.country}
                            style={{
                                width: '1.5em',
                                height: '1.5em'
                            }}
                        />
                        <Typography>{lang.label}</Typography>
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}
